import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { AZURE_CA_URLS } from '../../../app/shared/enums/HttpStatusCodes';
import { GESTION_CONTENIDO_ENDPOINTS, TENDERO_ENDPOINTS } from '../../shared/models/Constants';
import { SharedServiceService } from '../../shared/services/shared-service.service';
import {
    agreeLegals,
    errorGetLegalVersion,
    errorUpdateLegalVersion,
    errroAgreeLegals,
    errroGetLegals,
    getLegals,
    getLegalVersion,
    successAgreeLegals,
    successGetLegals,
    successGetLegalVersion,
    successUpdateLegalVersion,
    updateLegalVersion,
} from '../actions';

@Injectable()
export class LegalsEffets {
    constructor(
        private actions$: Actions
        , private httpS: SharedServiceService
    ) { }

    /**
     * * Acepta los legales
     */
    public agreeLegals$ = createEffect(
        () => this.actions$.pipe(
            ofType(agreeLegals),
            switchMap(
                () => this.httpS.executeRequestByUser(GESTION_CONTENIDO_ENDPOINTS.post_update_user_legal_version, null, this.httpS.getAzureCAUrl(AZURE_CA_URLS.CONTENIDO))
                    .pipe(
                        map(resp => successAgreeLegals(resp)),
                        catchError((err: Error) => of(errroAgreeLegals({ payload: err })))
                    )
            )
        )
    );

    /**
     * * Consulta los legales
     */
    public getLegals$ = createEffect(
        () => this.actions$.pipe(
            ofType(getLegals),
            switchMap(
                actions => this.httpS.executeFunctionDataUser(actions.api, null)
                    .pipe(
                        map(resp => successGetLegals(resp)),
                        catchError((err: Error) => of(errroGetLegals({ payload: err })))
                    )
            )
        )
    );

    /**
     * * Obtiene versión legal por ID
     */
    public getLegalVersion$ = createEffect(
        () => this.actions$.pipe(
            ofType(getLegalVersion),
            switchMap(
                actions => this.httpS.executeRequestByUser(TENDERO_ENDPOINTS.get_legal_version, actions)
                    .pipe(
                        map(resp => successGetLegalVersion(resp)),
                        catchError((err: Error) => of(errorGetLegalVersion({ payload: err })))
                    )
            )
        )
    );

    /**
     * * Actualiza versión legal
     */
    public updateLegalVersion$ = createEffect(
        () => this.actions$.pipe(
            ofType(updateLegalVersion),
            switchMap(
                actions => this.httpS.executeRequestByUser(TENDERO_ENDPOINTS.update_legal_version, actions)
                    .pipe(
                        map(resp => successUpdateLegalVersion(resp)),
                        catchError((err: Error) => of(errorUpdateLegalVersion({ payload: err })))
                    )
            )
        )
    );
}
